<template lang="html">
  <div class="formCon">
    <div v-for="(a, aIndex) in formData" :key="a.id">
      <div class="industryList" v-if="a.child.length">
        <div class="userHint">{{a.title}}<span>*</span></div>
        <div class="categorysList">
          <div v-for="(b, bIndex) in a.child" :key="b.id" class="categorys" :class="b.class" @click="getIndex(b.id, bIndex, a.identity_group_en_title, aIndex)">
            {{b.title}}
          </div>
        </div>
      </div>

      <div class="userInfo" v-else>
        <div class="userHint">{{a.title}}<span>*</span></div>
        <input :placeholder="'请输入'+a.title" name="infoInput" class="infoInput" type="text" @input="printValues(a.identity_group_en_title, a.value, aIndex)" v-model="a.value">
      </div>
    </div>

    <div class="submitBtn" @click="getSubmit">
      提交
    </div>

    <!-- 提示框 -->
    <div v-show="hintShow" class="hintMod">
      <p>{{hintCon}}</p>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  import WxShare from '@/utils/wxshare';
  import { pagebase } from '@/utils/http.js';

  var word = /^[\u4e00-\u9fa5a-zA-Z]{2,10}$/;
  var phone = /^1[3456789]\d{9}$/;
  var eMail = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/;

  export default {
    data() {
      return {
        userName: '',
        userCompany: '',
        userPosition: '',
        activityId: this.$route.query.aid,
        channelId: this.$route.query.channel || 0,
        formData: [],
        activityInfoData: {},

        sf: '',
        jsfx: [],
        hyly: [],
        zyzw: '',
        sjh: '',
        xxgs: '',
        yx: '',
        xm: '',
        ywdjr: '',

        identityGroup: [],
        toast: '',

        hintTime: 1,
        hintShow: false,
        hintCon: '',
        pagebase: pagebase,
      }
    },

    mounted() {
      this.init()
    },

    methods: {
      init() {
        this.getActivityInfo()
      },

      getActivityInfo() {
        this.$http({
          url: '/api/getH5ActivityInfo',
          method: 'get',
          params: {
            uid: Cookies.get('uid') || '',
            token: Cookies.get('token') || '',
            activity_id: this.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.activityInfoData = res.data;

            new WxShare().share({
              title: this.activityInfoData.title,
              desc: '邀请好友，分享得好礼，快来帮我助力',
              link: pagebase + '/#/customActivityHome?aid=' + this.activityId + '&channel=' + this.channelId,
              imgUrl: this.activityInfoData.cover,
            });

            this.getActivityForm()
          }
        })
      },

      getActivityForm() {
        this.$http({
          url: '/api/getH5ActivityFormInfo',
          method: 'get',
          params: {
            activity_id: this.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            // if (this.activityInfoData.is_submit) {
              this.getUserActRegInfo();
            // }

            this.formData = res.data;

            for (var a = 0; a < this.formData.length; a++) {
              this.identityGroup.push(this.formData[a].identity_group_en_title)
              this.formData[a]['value'] = '';
              this.formData[a]['toastType'] = false;

              for (var b = 0; b < this.formData[a].child.length; b++) {
                this.$set(this.formData[a].child[b], 'class', ' ')
              }
            }
          }
        })
      },

      getUserActRegInfo() {
        this.$http({
          url: '/api/getUserActRegInfo',
          method: 'get',
          params: {
            uid: Cookies.get('uid'),
            token: Cookies.get('token'),
          },
        }).then((res) => {
          if (res.code >= 0) {
            
            for (var a = 0; a < this.formData.length; a++) {
              if (this.formData[a].identity_group_en_title == 'xm' && res.data.xm != '') {
                this.formData[a]['value'] = res.data.xm;
                this.formData[a]['toastType'] = true;
              } else if (this.formData[a].identity_group_en_title == 'zyzw' && res.data.zyzw != '') {
                this.formData[a]['value'] = res.data.zyzw;
                this.formData[a]['toastType'] = true;
              } else if (this.formData[a].identity_group_en_title == 'xxgs' && res.data.xxgs != '') {
                this.formData[a]['value'] = res.data.xxgs;
                this.formData[a]['toastType'] = true;
              } else if (this.formData[a].identity_group_en_title == 'yx' && res.data.yx != '') {
                this.formData[a]['value'] = res.data.yx;
                this.formData[a]['toastType'] = true;
              } else if (this.formData[a].identity_group_en_title == 'sjh' && res.data.sjh != '') {
                this.formData[a]['value'] = res.data.sjh;
                this.formData[a]['toastType'] = true;
              } else if (this.formData[a].identity_group_en_title == 'sf') {
                for (var j = 0; j < this.formData[a].child.length; j++) {
                  this.$set(this.formData[a].child[j], 'class', 'false')
                  if (this.formData[a].child[j].id == res.data.sf) {
                    this.sf = res.data.sf;
                    this.formData[a].child[j]['class'] = 'active';
                    this.formData[a].toastType = true;
                  }
                }
              } else if (this.formData[a].identity_group_en_title == 'jsfx') {
                for (var i = 0; i < res.data.jsfx.length; i++) {
                  this.jsfx.push(Number(res.data.jsfx[i]))
                  
                  for (var h = 0; h < this.formData[a].child.length; h++) {
                    if (this.formData[a].child[h].id == res.data.jsfx[i]) {
                      this.formData[a].child[h]['class'] = 'active';
                      this.formData[a].toastType = true;
                    }
                  }
                }
              } else if (this.formData[a].identity_group_en_title == 'hyly') {
                for (var g = 0; g < res.data.hyly.length; g++) {
                  this.hyly.push(Number(res.data.hyly[g]))
                  
                  for (var k = 0; k < this.formData[a].child.length; k++) {
                    if (this.formData[a].child[k].id == res.data.hyly[g]) {
                      this.formData[a].child[k]['class'] = 'active';
                      this.formData[a].toastType = true;
                    }
                  }
                }
              }
            }
          }

          return this.formData = [...this.formData]
        })
      },

      getIndex(bId, bIndex, aTitle, aIndex) {
        if (aTitle == 'sf') {
          for (var j = 0; j < this.formData[aIndex].child.length; j++) {
            this.$set(this.formData[aIndex].child[j], 'class', 'false')
            if (this.formData[aIndex].child[j].id == bId) {
              this.sf = bId;
              this.formData[aIndex].child[bIndex]['class'] = 'active';
              this.formData[aIndex].toastType = true;
            }
          }
        } else if (aTitle == 'jsfx') {
          if (this.jsfx.indexOf(bId) !== -1) {
            this.jsfx.splice(this.jsfx.indexOf(bId), 1);
            this.formData[aIndex].child[bIndex]['class'] = 'false';
          } else {            
            this.jsfx.push(bId);
            this.formData[aIndex].child[bIndex]['class'] = 'active';
          }

          if (this.jsfx.length > 0) {
            this.formData[aIndex].toastType = true;
          } else {
            this.formData[aIndex].toastType = false;
          }
        } else if (aTitle == 'hyly') {
          if (this.hyly.indexOf(bId) !== -1) {
            this.hyly.splice(this.hyly.indexOf(bId), 1);
            this.formData[aIndex].child[bIndex]['class'] = 'false';
          } else {
            this.hyly.push(bId);
            this.formData[aIndex].child[bIndex]['class'] = 'active';
          }

          if (this.hyly.length > 0) {
            this.formData[aIndex].toastType = true;
          } else {
            this.formData[aIndex].toastType = false;
          }
        }
      },

      printValues(aTitle, aValue, aIndex) {
        if (aTitle == 'zyzw' && aValue != '' && word.test(aValue)) {
          this.zyzw = aValue;
          this.formData[aIndex].toastType = true;
        } else if (aTitle == 'sjh' && aValue != '' && phone.test(aValue)) {
          this.sjh = aValue,
          this.formData[aIndex].toastType = true;
        } else if (aTitle == 'xxgs' && aValue != '' && word.test(aValue)) {
          this.xxgs = aValue;
          this.formData[aIndex].toastType = true;
        } else if (aTitle == 'yx' && aValue != '' && eMail.test(aValue)) {
          this.yx = aValue;
          this.formData[aIndex].toastType = true;
        } else if (aTitle == 'xm' && aValue != '' && word.test(aValue)) {
          this.xm = aValue;
          this.formData[aIndex].toastType = true;
        } else if (aTitle == 'ywdjr' && aValue != '' && word.test(aValue)) {
          this.ywdjr = aValue;
          this.formData[aIndex].toastType = true;
        } else {
          this.formData[aIndex].toastType = false;
        }
      },

      // 提交
      getSubmit() {
        for (var c = 0; c < this.identityGroup.length; c++) {
          if (!this.formData[c].toastType) {
            if (this.formData[c].value != '') {
              this.setHintCon('您输入的' + this.formData[c].title + '有误');
              return;
            } else {
              this.setHintCon('请输入您的' + this.formData[c].title);
              return;
            }
          }
        }

        this.$http({
          url: '/api/updateH5ActivityRegInfo',
          method: 'get',
          params: {
            uid: Cookies.get('uid'),
            token: Cookies.get('token'),
            activity_id: this.activityId,
            yx: this.yx || '',
            xm: this.xm || '',
            hyly: this.hyly.join(',') || '',
            jsfx: this.jsfx.join(',') || '',
            sjh: this.sjh || '',
            xxgs: this.xxgs || '',
            sf: this.sf || '',
            zyzw: this.zyzw || '',
          },
        }).then((res) => {
          if (res.code >= 0) {
            if (this.activityInfoData.type == 1) {
              this.$router.push({
                path: '/customActivityInviteSucceed',
                query: {
                  aid: this.activityId,
                  channel: this.channelId,
                }
              })
            } else if (this.activityInfoData.type == 3) {
              this.$router.push({
                path: '/customActivityDetails',
                query: {
                  aid: this.activityId,
                  channel: this.channelId,
                }
              })
            }
          }
        })
      },

      setHintCon(e) {
        window.clearInterval(this.timers)
        this.hintCon = e;
        this.hintShow = true;
        this.timers = window.setInterval(() => {
          this.hintTime--
          if (this.hintTime < 0) {
            window.clearInterval(this.timers)
            this.hintShow = false
            this.hintTime = 1
          }
        }, 1000)
      },
    },
  }
</script>

<style lang="css" scoped>
  .formCon {
    box-sizing: border-box;
    padding: 0 2.1rem;
    padding-bottom: 3rem;
  }

  .industryList {
    margin-top: 2.5rem;
  }

  .categorysList {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .categorys {
    width: 16.1rem;
    height: 3.55rem;
    border-radius: 3.55rem;
    background-color: #F6F6F6;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .active {
    background-color: #FFD4D4;
    color: #F7443F;
  }

  .userInfo {
    margin-top: 2.5rem;
    border-bottom: .05rem solid #D3D3D3;
  }

  .userHint {
    color: #1D2023;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .userHint span {
    color: #F7443F;
    margin-left: .1rem;
  }

  .infoInput {
    width: 100%;
    margin: 1rem 0;
    border: none;
    outline: none;
  }

  .infoInput[name="infoInput"]::-webkit-input-placeholder {
    color: #C0C4CC;
  }

  .submitBtn {
    width: 100%;
    height: 4.5rem;
    margin-top: 3rem;
    border-radius: 4.5rem;
    background: linear-gradient(to top, #EA1A14, #F7443F);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.7rem;
    color: #FFFFFF;
  }

  /* 提示 */
  .hintMod {
    box-sizing: border-box;
    position: fixed;
    bottom: 45%;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 100;
  }

  .hintMod p {
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 1.3rem;
    color: #FFFFFF;
    max-width: 65%;
    height: 4rem;
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>